define(['exports', 'react', 'lodash', 'classnames', '../../i18n', '../../assets/carat-icon.svg', '../../assets/view-black.svg', '../../assets/pdf-file.svg'], function (exports, _react, _lodash, _classnames, _i18n, _caratIcon, _viewBlack, _pdfFile) {
	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _react2 = _interopRequireDefault(_react);

	var _lodash2 = _interopRequireDefault(_lodash);

	var _classnames2 = _interopRequireDefault(_classnames);

	var _i18n2 = _interopRequireDefault(_i18n);

	var _caratIcon2 = _interopRequireDefault(_caratIcon);

	var _viewBlack2 = _interopRequireDefault(_viewBlack);

	var _pdfFile2 = _interopRequireDefault(_pdfFile);

	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : {
			default: obj
		};
	}

	function _classCallCheck(instance, Constructor) {
		if (!(instance instanceof Constructor)) {
			throw new TypeError("Cannot call a class as a function");
		}
	}

	var _createClass = function () {
		function defineProperties(target, props) {
			for (var i = 0; i < props.length; i++) {
				var descriptor = props[i];
				descriptor.enumerable = descriptor.enumerable || false;
				descriptor.configurable = true;
				if ("value" in descriptor) descriptor.writable = true;
				Object.defineProperty(target, descriptor.key, descriptor);
			}
		}

		return function (Constructor, protoProps, staticProps) {
			if (protoProps) defineProperties(Constructor.prototype, protoProps);
			if (staticProps) defineProperties(Constructor, staticProps);
			return Constructor;
		};
	}();

	function _possibleConstructorReturn(self, call) {
		if (!self) {
			throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
		}

		return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}

	function _inherits(subClass, superClass) {
		if (typeof superClass !== "function" && superClass !== null) {
			throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
		}

		subClass.prototype = Object.create(superClass && superClass.prototype, {
			constructor: {
				value: subClass,
				enumerable: false,
				writable: true,
				configurable: true
			}
		});
		if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}

	var Student = function (_React$Component) {
		_inherits(Student, _React$Component);

		function Student(props) {
			_classCallCheck(this, Student);

			var _this = _possibleConstructorReturn(this, (Student.__proto__ || Object.getPrototypeOf(Student)).call(this, props));

			_this.state = {
				mouseOver: false
			};
			return _this;
		}

		_createClass(Student, [{
			key: 'fetchReport',
			value: function fetchReport(candidate) {
				var sessionId = this.props.session.sessionId;

				if (sessionId && candidate && candidate.candidateId) window.open(window.location.origin + '/reports/sessions/' + sessionId + '/candidates/' + candidate.candidateId);
			}
		}, {
			key: 'renderCarats',
			value: function renderCarats(carats) {
				return _react2.default.createElement(
					'div',
					{ className: 'flex items-center' },
					_react2.default.createElement(
						'div',
						{ className: 'mr1 flex items-center' },
						_react2.default.createElement(_caratIcon2.default, null)
					),
					_react2.default.createElement(
						'div',
						null,
						carats
					)
				);
			}
		}, {
			key: 'renderStudent',
			value: function renderStudent() {
				var _this2 = this;

				var _props = this.props,
				    session = _props.session,
				    candidate = _props.candidate,
				    getReportDownloadUrl = _props.getReportDownloadUrl;

				var isClickable = candidate.assessmentStatus === 'Completed';
				var styles = {
					borderBottom: '1px solid #EEE'
				};

				var shouldRenderTotalCarats = _lodash2.default.isNumber(candidate.totalCaratsEarned) || _lodash2.default.isString(candidate.totalCaratsEarned);

				var reportDownloadUrl = getReportDownloadUrl && getReportDownloadUrl(session.sessionId, candidate.candidateId);

				return _react2.default.createElement(
					'div',
					{
						className: 'flex justify-between items-center p2 mx2 black',
						style: styles },
					_react2.default.createElement(
						'div',
						{ className: 'col-1' },
						candidate.rollNo
					),
					_react2.default.createElement(
						'div',
						{ className: 'col-2' },
						_lodash2.default.upperCase(candidate.firstName) + ' ' + _lodash2.default.upperCase(candidate.lastName)
					),
					_react2.default.createElement(
						'div',
						{ className: 'col-1' },
						this.renderCarats(candidate.caratsEarned)
					),
					_react2.default.createElement(
						'div',
						{ className: (0, _classnames2.default)('col-2 flex items-center', { 'display-none': !shouldRenderTotalCarats }) },
						_react2.default.createElement(
							'div',
							{ className: 'mr1' },
							_i18n2.default.t('dk-ui-lib.sessions.over_all') + ' :'
						),
						this.renderCarats(candidate.totalCaratsEarned)
					),
					_react2.default.createElement(
						'div',
						{ className: (0, _classnames2.default)('flex items-center col-2 brand-color clickable', { 'display-none': !isClickable }), onTouchTap: function onTouchTap() {
								return isClickable ? _this2.fetchReport(candidate) : null;
							} },
						_react2.default.createElement(_viewBlack2.default, { className: 'flex items-center svg-icon svg-1x' }),
						_react2.default.createElement(
							'div',
							{ className: 'ml1' },
							_i18n2.default.t('dk-ui-lib.reports.view_report')
						)
					),
					_react2.default.createElement(
						'div',
						{ className: (0, _classnames2.default)('flex items-center col-2 clickable', { 'display-none': !(reportDownloadUrl && isClickable) }) },
						_react2.default.createElement(_pdfFile2.default, { className: 'flex items-center svg-icon svg-1x' }),
						_react2.default.createElement(
							'a',
							{ className: 'brand-color ml1', style: { textDecoration: 'none', fontSize: '1rem' }, href: reportDownloadUrl, download: true },
							_i18n2.default.t('dk-ui-lib.reports.download')
						)
					)
				);
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					null,
					this.renderStudent()
				);
			}
		}]);

		return Student;
	}(_react2.default.Component);

	exports.default = Student;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/dk-ui-lib/lib/session-reports/Candidate.js
// module id = 1211
// module chunks = 0